module.exports = __webpack_public_path__ + "img/rounded-cross-hover.259036b9.svg";